'use strict';

import GraphQL from './graphql';

export default {

  search(zip, type) {
    const query = `{
      searchByZip(
        zip: "${zip}",
        type: "${type}"
      ) {
        pageInfo {
          hasNextPage
        }
        edges {
          node {
            ... on District {
              type
              id
              name
              state_name
              state_abbreviation
              path
              county_names
            }
            ... on Person {
              type
              id
              full_name
              party_name
              path
            }
            ... on Election {
              type
              id
              year
              name
              district_name
              state_name
              path
            }
          }
        }
      }
    }`;

    return GraphQL.post(query);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/vue/services/search-by-zip.js